import React from 'react';

const useEntity = <T>(createEntity: () => T, deps: any[]): T => {
    const entity = React.useMemo(createEntity, deps);

    return entity;
};

export { useEntity };
